import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28a1e7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown-container" }

import { useEventListener } from "@vueuse/core";
import { ref } from "vue";
import IconChevronDown from "../icons/IconChevronDown.vue";
import TressButton from "../TressButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressDropdown',
  props: {
    title: {}
  },
  setup(__props: any) {

const props = __props;



const buttonRef = ref<InstanceType<typeof TressButton> | null>(null);
const contentRef = ref<HTMLDialogElement | null>(null);

const active = ref(false);
function toggle() {
  if (active.value) {
    close();
  } else {
    open();
  }
}
function close() {
  active.value = false;
  contentRef.value?.close();
}
function open() {
  active.value = true;
  contentRef.value?.show();
}
useEventListener(contentRef, "close", () => {
  active.value = false;
  buttonRef.value?.$el.blur();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "trigger", { open: open }, () => [
      _createVNode(TressButton, {
        ref_key: "buttonRef",
        ref: buttonRef,
        class: "dropdown-button button--button-text-icon",
        onClick: toggle
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.title) + " ", 1),
          _createVNode(IconChevronDown, {
            class: _normalizeClass(["dropdown-button__icon", { active: active.value }])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("dialog", {
      closedby: "any",
      ref_key: "contentRef",
      ref: contentRef,
      class: "dropdown-content"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 512)
  ]))
}
}

})